import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../../util/abstract.component';
import { SessaoService } from '../../services/sessao.service';

declare var $ :any;

@Component({
  selector: 'rel-extrato-contrato',
  templateUrl: './rel-extrato-contrato.component.html',
  styleUrls: ['./rel-extrato-contrato.component.css']
})
export class RelExtratoContratoComponent extends AbstractComponent implements OnInit {

  constructor(private sessaoService: SessaoService) {
    super(sessaoService);
  }

  ngOnInit() {
  }

  /**
   * Realiza a impressão da página
   */
  imprimir() {
    $(".page").removeClass("toggled");
    // $('.caminhoPao').show();
    // $('.relHide').hide();
    $('#m-rel-extrato-contrato').modal('close');
    setTimeout(function(){
      window.print();
    }, 500);
    
  }

  /**
   * Fecha a popup
   */
  fechar() {
    // $('.caminhoPao').show();
    // $('.modal.relHide').show();
    $('#m-rel-extrato-contrato').modal('close');
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/rel-extrato-contrato/rel-extrato-contrato.component.ts